var _excluded = ["color", "loading", "size", "type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Fragment } from "react";
import { ClipLoader, FadeLoader, PropagateLoader, RingLoader } from "react-spinners";
var Loader = function Loader(_ref) {
  var color = _ref.color,
    loading = _ref.loading,
    size = _ref.size,
    type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Fragment, null, type === 'clip' && /*#__PURE__*/React.createElement(ClipLoader, Object.assign({
    size: size,
    color: color,
    loading: loading
  }, rest)), type === 'propagate' && /*#__PURE__*/React.createElement(PropagateLoader, Object.assign({
    size: size,
    color: color,
    loading: loading
  }, rest)), type === 'fade' && /*#__PURE__*/React.createElement(FadeLoader, Object.assign({
    color: color,
    loading: loading
  }, rest)), type === 'ring' && /*#__PURE__*/React.createElement(RingLoader, Object.assign({
    color: color,
    loading: loading
  }, rest)));
};
Loader.defaultProps = {
  color: '#ffffff',
  loading: false,
  size: '18px',
  type: 'clip'
};
export default Loader;